export default __webpack_public_path__ + "static/media/goose.ea16da24.png";